/**
 * Extract a canonical 11-character YouTube video id from a URL or bare id.
 * Handles watch, embed, youtu.be, shorts, live, and query ?v=.
 */
export function extractYouTubeVideoId(input) {
  if (!input || typeof input !== "string") return null;
  const s = input.trim();
  if (!s || s === "null" || s === "undefined") return null;
  if (/^[a-zA-Z0-9_-]{11}$/.test(s)) return s;

  try {
    const u = /^https?:/i.test(s) ? new URL(s) : new URL("//" + s.replace(/^\/+/, ""), "https://youtube.com");
    const host = u.hostname.replace(/^www\./, "");

    if (host === "youtu.be") {
      const seg = u.pathname.split("/").filter(Boolean)[0] || "";
      return /^[a-zA-Z0-9_-]{11}$/.test(seg) ? seg : null;
    }

    if (
      host === "youtube.com" ||
      host === "m.youtube.com" ||
      host === "youtube-nocookie.com" ||
      host === "music.youtube.com"
    ) {
      const v = u.searchParams.get("v");
      if (v && /^[a-zA-Z0-9_-]{11}$/.test(v)) return v;

      const parts = u.pathname.split("/").filter(Boolean);
      for (const k of ["embed", "shorts", "live", "v"]) {
        const i = parts.indexOf(k);
        const slug = i >= 0 ? parts[i + 1] : null;
        if (slug && /^[a-zA-Z0-9_-]{11}$/.test(slug)) return slug;
      }
    }
  } catch {
    /* invalid URL — try regex fallback */
  }

  const m = s.match(/(?:youtube\.com\/watch\?(?:[^\s*&]*[&])?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
  if (m?.[1]) return m[1];

  const m2 = s.match(/youtube\.com\/(?:embed\/|shorts\/|live\/)([a-zA-Z0-9_-]{11})/);
  if (m2?.[1]) return m2[1];

  return null;
}
